export const strings = {
  presenter_access:
    "Sunucu olarak giriş yaptınız. Lütfen mikrofon ve kamera erişiminden yararlanmak için web seminerini yeni ekranda açmak üzere {link}'e tıklayın.",
  webinar: 'Webinar',
  webinars_by: "Webinar'lar tarafından",
  presenter_details: 'Sunucunun Ayrıntıları',
  ongoing: 'Devam eden',
  live_now: 'Canlı',
  live_webinars: 'Canlı webinarlar',
  upcoming_webinars: 'Yaklaşan webinarlar',
  recommended_webinars: 'Önerilen webinarlar',
  previous_webinars: 'Önceki webinarlar',
  starts_in: 'Başlıyor',
  no_webinars: 'Webinar yok',
  join_webinar: "Webinar'a katılın",
  by_clicking: "Kayıt'a tıklayarak şunları kabul etmiş olursunuz:",
  tnc: 'Hüküm ve koşullar',
  no_webinars_message: 'Gösterilecek canlı web semineri yok',
  create_webinar: 'Bir Web Semineri Oluşturun',
  new_webinar: 'Yeni Web Semineri',
  edit_webinar: "Webinar'ı Düzenle",
  cover_image: 'Kapak Resmi',
  presenter: 'Sunucu(lar)',
  webinar_title: 'Webinar Başlığı',
  title_placeholder: 'Başlık Girin',
  timezone: 'Zaman Dilimi',
  duration: 'Süre (dakika olarak)',
  webinar_type: 'Webinar Türü',
  location: 'Webinar Yeri',
  address: 'Adresi Girin',
  start_time: 'Başlangıç Zamanı',
  delete_webinar: 'Web Seminerini Sil',
  cancel: 'İptal',
  save: 'Kaydet',
  create: 'Oluştur',
  end_time: 'Bitiş Zamanı',
  source: 'Kaynak',
  source_placeholder: 'URL bağlantısını buraya yapıştırın',
  description: 'Webinar Hakkında',
  desc_placeholder: 'Buraya yaz...',
  payment_method: 'Ödeme yöntemi',
  time_placeholder: 'Tarih ve saati seçin',
  errors: {
    cover_required: 'Webinar kapak resmini yüklemeniz gerekiyor',
    cover_uploading: 'Kapak yükleniyor',
    title_required: 'Webinar Başlığı gereklidir',
    title_min_length: 'Web semineri başlığı en az 3 karakter olmalıdır',
    title_max_length: 'Web semineri başlığı 250 karakterden uzun olamaz',
    timezone_id_required: 'Lütfen ilgili saat dilimini seçin',
    privacy_required: 'Gizlilik gereklidir',
    invalid_time:
      'Başlangıç saati, geçerli saatten en az bir saat sonra olmalıdır',
    source_url: 'Kaynak geçerli bir URL olmalıdır',
    sub_url_required: 'Kaynak girilmelidir',
    start_time_required: 'Başlangıç Saati boş bırakılmamalıdır',
    source_max_limit: 'Kaynak 300 karakterden uzun olamaz',
    description_required: 'Web semineri açıklaması gereklidir',
    description_min_length:
      'Web semineri açıklaması en az 3 karakter olmalıdır',
    description_max_length:
      'Web semineri açıklaması 2500 karakterden uzun olamaz',
    presenter_name_required: 'Lütfen sunucunun adını girin',
    presenter_about_required: 'Lütfen sunucu hakkında bilgi girin',
    presenter_required: 'Lütfen sunucuları seçin',
    presenter_avatar_required: 'Lütfen sunucu avatarını yükleyin',
  },
  presenter_name: 'Sunucunun Adı',
  about_presenter: 'Sunucu Hakkında',
  add: 'Eklemek',
  presenter_name_placeholder: 'Sunucunun adını buraya girin...',
  presenter_str: 'Sunucu',
  see_all: 'Tümünü Gör',
  webinars: 'Web seminerleri',
  click_here: 'Buraya tıklayın',
  load_more: 'Daha fazla yükle',
  hours_ago: ' saatler önce',
  hour_ago: 'bir saat önce',
  days_ago: ' günler önce',
  days_to_go: 'günler kaldı',
  previous: 'Öncesi',
  recommended: 'Önerilen',
  remove: 'Kaldır',
  add_presenter: 'Sunucu Ekle',
  remove_presenter_alert: 'Bu sunucuyu kaldırmak istediğinizden emin misiniz?',
  remove_registrant_alert:
    'Bu kayıtlı kişiyi kaldırmak istediğinizden emin misiniz?',
  webinar_detail: 'Webinar Detayları',
  presenters: 'Sunucular',
  manage_registrants: 'Kayıtlıları Yönet',
  export_member: 'Microsite Üyesini İndir',
  upload_registrant: 'Kayıtlı Kişiyi Yükle',
  manage_webinar: "Webinar'ı yönetin",
  copy_link: 'Bağlantıyı kopyala',
  copied: 'Kopyalandı',
  find_remove_participants: 'Katılımcıları bul ve kaldır',
  upload_registrant_list: 'Katılımcı Listesini Yükle',
  no_registrant_title: 'Kayıtlı Kişi Yok',
  no_registrant_para:
    'Katılımcı eklemek için lütfen .xlsx veya .xls dosyasını yükleyin ve yükleme sekmesine basın.',
  public: 'Topluluk',
  private: 'Özel',
  closed: 'Kapalı',
  open: 'Açık',
  public_desc: "SMM Space'in tüm kullanıcılarına açıktır",
  private_desc: 'Sadece mikro site kullanıcılarına açıktır',
  closed_desc:
    'Sadece seçili kullanıcı grubuna açıktır. (Bu kullanıcılar Kayıtlıları Yönet sekmesinden yüklenebilir)',
  open_desc:
    'Tüm SMM Space kullanıcılarına ve SMM Space dışındakilere açıktır. SMM Space kullanıcısı olmayanlar için ayrı bir kayıt bağlantısı olacak.',
};
